const WEBVIEW_STYLE = `body{font-family:-apple-system,BlinkMacSystemFont,"PingFang TC","Helvetica Neue",sans-serif;padding:16px 18px 32px;line-height:1.65;margin:0;color:#222;font-size:16px;}h1{font-size:22px;margin:0 0 12px;}h2{font-size:18px;margin:24px 0 8px;}p,li{margin:0 0 10px;}ul{padding-left:1.2em;}a{color:#1565c0;}.muted{color:#666;font-size:14px;}`;

/** CRM 編輯器用（不含完整 document 外殼） */
export const USER_PRIVACY_POLICY_BODY_HTML = `<h1>用戶私隱政策</h1>
<p><strong>最後更新：</strong>2026年10月31日</p>
<p>搭的（Take Taxi，以下稱「我們」）營運乘客版及司機版流動應用程式（以下合稱「本 App」）及相關網上服務。本政策說明我們如何收集、使用、保存及保護你的個人資料。</p>
<p class="muted">本政策適用於香港用戶。使用本 App 即表示你已閱讀並理解本政策。</p>

<h2>1. 我們收集的資料</h2>
<ul>
  <li><strong>帳戶資料：</strong>香港流動電話號碼、顯示名稱（如適用）。</li>
  <li><strong>位置資料：</strong>上車點、目的地、行程中位置（用於配對司機、導航及完成柯打）。</li>
  <li><strong>訂單及行程資料：</strong>叫車選項、備註、車資估算、積分使用、評價及行程訊息。</li>
  <li><strong>裝置及技術資料：</strong>裝置識別碼、推送通知 token、App 版本、語言設定及診斷紀錄（如 Crashlytics）。</li>
  <li><strong>司機額外資料（司機版）：</strong>駕駛執照／行車證等上載文件、車牌、銀行戶口（用於積分結算）、開工／收工電話。</li>
</ul>

<h2>2. 使用目的</h2>
<ul>
  <li>提供、維持及改善叫車配對與行程服務；</li>
  <li>身份驗證、帳戶安全及防止濫用；</li>
  <li>推送行程狀態、訊息及重要通知；</li>
  <li>客戶支援、爭議處理及法律合規；</li>
  <li>統計及營運分析（在合理範圍內去識別化）。</li>
</ul>

<h2>3. 法律依據及同意</h2>
<p>我們主要按提供服務所需處理你的資料。部分功能（例如推送通知、精準定位）需你在裝置或 App 內授予權限；你可隨時在系統設定中關閉，但可能影響部分功能。</p>

<h2>4. 與第三方分享</h2>
<p>我們不會出售你的個人資料。在提供服務時，我們可能使用以下類別的服務供應商（彼等須按合約保障資料）：</p>
<ul>
  <li>身份驗證及雲端服務（例如 Google Firebase）；</li>
  <li>地圖及地址服務（例如 Google Maps）；</li>
  <li>推送通知（例如 OneSignal）；</li>
  <li>雲端託管及資料庫（我們的伺服器設於受管控的雲端環境）。</li>
</ul>
<p>若法律要求或為保護用戶及公眾安全，我們可能向執法或監管機關披露必要資料。</p>

<h2>5. 保存期限</h2>
<p>我們在提供服務及處理爭議、會計、法律義務所需的期間內保留資料，之後會刪除或匿名化，除非法律要求更長保存期。</p>

<h2>6. 資料安全</h2>
<p>我們採取合理技術及組織措施（例如加密傳輸、存取控制）保護資料，但互聯網傳送無法保證絕對安全。</p>

<h2>7. 你的權利</h2>
<p>在適用法律下，你可要求查閱、更正或刪除你的個人資料，或反對某些處理。請透過下方聯絡方式提出；我們可能需驗證你的身份。</p>

<h2>8. 兒童</h2>
<p>本 App 並非針對 18 歲以下人士。若你認為我們誤收集了未成年人的資料，請聯絡我們以便刪除。</p>

<h2>9. 政策更新</h2>
<p>我們可能不時更新本政策，並於本頁及 App 內公布。重大變更時，我們會以合理方式通知你。</p>

<h2>10. 聯絡我們</h2>
<p>私隱或個人資料查詢：<a href="mailto:support@taxima.hk">support@taxima.hk</a></p>
<p>網上版本：<a href="https://app.hktaketaxi.online/privacy">https://app.hktaketaxi.online/privacy</a></p>`;

export function buildUserPrivacyPolicyDocumentHtml(): string {
  return `<!DOCTYPE html>
<html lang="zh-Hant">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>用戶私隱政策 · 搭的</title>
  <style>${WEBVIEW_STYLE}</style>
</head>
<body>
${USER_PRIVACY_POLICY_BODY_HTML}
</body>
</html>`;
}
